<template>
  <PageContentDocument
    :page-data="pageData"
    :page-data-default-locale="pageDataDefaultLocale"
    :show-privacy-subpages="true"
  />
</template>

<script setup>
import { queryPagePrivacyPolicy } from '../../data-layer/queries'

const { setTheme } = useTheme()
const { screen } = useScreen()
const route = useRoute()
const { useAsyncDataWithQuery, onAfterAdyenData, onBeforeAdyenData, localeGlobalContentData, labels } =
  useMainPageData()
const { getSlug, getSlugParent } = usePageUtils()
const slug = getSlug(route.path) || 'privacy-policy'
const { defaultLocale } = useLocales()
const { locale: localeRef } = useI18n()

await onBeforeAdyenData({ globalDataContentType: 'PagePrivacyPolicy', withRoutes: true })

const { data } = await useAsyncData('privacy-policy-' + slug + '-' + localeRef.value, async () => {
  const page = await useAsyncDataWithQuery(queryPagePrivacyPolicy, {})

  let pageDataDefaultLocale = null
  const pageId = page.pageData.sysId

  if (page.pageData.content.defaultLocaleFallbackEnabled) {
    try {
      pageDataDefaultLocale = await useAsyncDataWithQuery(queryPagePrivacyPolicy, {
        locale: defaultLocale,
        variables: { sysId: pageId }
      })
    } catch (e) {
      console.error(`>>> pageDataDefaultLocale failed for ${slug} in ${localeRef.value} `, e.message)
    }
  }

  return {
    pageData: page.pageData,
    pageDataDefaultLocale
  }
})

const pageData = computed(() => {
  return data.value?.pageData
})

const pageDataDefaultLocale = computed(() => {
  return data.value?.pageDataDefaultLocale?.pageData
})

setTheme('light')

await onAfterAdyenData(data.value)
</script>

<style lang="scss" scoped>
@import 'awds/foundation-vars.scss';

:deep(.nuxt-link-active) {
  color: $color-black !important;
  font-weight: $font-weight !important;
}
</style>
